import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "scene-intro",
  id: "intro"
}
const _hoisted_2 = { class: "static-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "sokolovskyi"),
  /*#__PURE__*/_createElementVNode("span", { class: "func" }, ".is()")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "-purple" }, "Anton Sokolovskyi", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "-gray" }, "Frontend developer", -1)

import TextBlock from "@/components/Common/TextBlock.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'IntroScene',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(TextBlock, null, {
        default: _withCtx(() => [
          _hoisted_4,
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ]))
}
}

})